import styled from 'styled-components';

const SearchConditionStyled = styled.div`
  width: 296px;
  .search-content-wrap {
    padding: 24px;
    padding-bottom: 0;
    .search-content-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .label-content {
        width: 100%;
      }
      .search {
        margin-left: 24px;
        width: 48px;
        height: 48px;
        min-width: 0;
        flex-shrink: 0;
        .MuiButton-startIcon {
          margin: 0;
        }
      }
    }
    .button-group {
      display: flex;
      gap: 16px;
      margin-top: 24px;
    }
  }
`;
export default SearchConditionStyled;
